import {useCurrentRepository} from '@github-ui/current-repository'
import {useCurrentUser} from '@github-ui/current-user'
import {dismissRepositoryNoticePathPath, repositoryPath} from '@github-ui/paths'
import {verifiedFetch} from '@github-ui/verified-fetch'
import {BranchName, Button, Heading, Link, Popover} from '@primer/react'
import {useState} from 'react'

import styles from './ParentBranchRenamePopover.module.css'

export default function ParentBranchRenamePopover({
  branchName,
  nameWithOwner,
}: {
  branchName: string
  nameWithOwner: string
}) {
  const [hidden, setHidden] = useState(false)
  const currentUser = useCurrentUser()
  const repo = useCurrentRepository()

  const onDismissPopover = () => {
    if (!currentUser) return
    const dismissPath = dismissRepositoryNoticePathPath({login: currentUser.login})
    const form = new FormData()
    form.append('_method', 'delete')
    form.append('repository_id', repo.id.toString())
    form.append('notice_name', 'repo_parent_default_branch_rename')
    verifiedFetch(dismissPath, {
      method: 'POST',
      body: form,
    })
    setHidden(true)
  }

  return (
    <Popover open={!hidden} caret="top-left" className={styles.Popover}>
      <Popover.Content className={styles.Popover_Content}>
        <Heading as="h4" className={styles.Heading}>
          The default branch on the parent repository has been renamed!
        </Heading>
        <p>
          <BranchName>{nameWithOwner}</BranchName> renamed its default branch{' '}
          <BranchName className={styles.BranchName}>{branchName}</BranchName>
        </p>
        <p>
          You can rename this fork&apos;s default branch to match in{' '}
          <Link inline href={repositoryPath({owner: repo.ownerLogin, repo: repo.name, action: 'settings'})}>
            branch settings
          </Link>
        </p>
        <Button onClick={onDismissPopover}>OK, got it</Button>
      </Popover.Content>
    </Popover>
  )
}
